// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3UNmz","messages":"Chat_messages__3ckVB","dateDivider":"Chat_dateDivider__132e8"};